export const environment = {
  production: true,
  appUrl: 'https://hominfogov.enap.gov.br',
  apiUrl: 'https://homapi-infogov.enap.gov.br/api',
};
